var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcelExport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 32,
    height: 34,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 32,
    height: 34,
    rx: 7.5,
    stroke: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9.25V16.75H15.75V9.25H8.25ZM9.5 10.5H14.5V15.5H9.5V10.5Z",
    fill: "#00B6CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7505 26.75H8.25049V19.25H15.7505V26.75Z",
    fill: "#00B6CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7505 10.5H18.2505V11.75H25.7505V10.5Z",
    fill: "#00B6CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2505 20.5H18.2505V21.75H23.2505V20.5Z",
    fill: "#00B6CE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2505 24.25H18.2505V25.5H23.2505V24.25Z",
    fill: "#00B6CE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7505 14.25H18.2505V15.5H25.7505V14.25Z",
    fill: "#00B6CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelExport);
export default __webpack_public_path__ + "static/media/Excel Export.a71fec262d3d29f6fde5cba7e999347b.svg";
export { ForwardRef as ReactComponent };